import { motion, useTransform, useScroll } from "framer-motion";
import React, { useRef } from "react";
import {HiArrowRight} from "react-icons/hi2";
import {BsArrow90DegRight} from "react-icons/bs";

const HorizontalScrollCarousel = () => {
    const targetRef = useRef(null);
    const { scrollYProgress } = useScroll({
        target: targetRef,
    });

    const x = useTransform(scrollYProgress, [0, 1], ["1.5%", "-95%"]);

    return (
        <section ref={targetRef} className="relative h-[300vh] ">
            <div className="sticky top-0 flex h-screen items-center overflow-hidden">
                <motion.div style={{ x }} className="flex gap-4">
                    {cards.map((card) => {
                        return <Card card={card} key={card.id} />;
                    })}
                </motion.div>
            </div>
        </section>
    );
};

const Card = ({ card }) => {
    return (
        <div
            key={card.id}
            className="group relative h-screen sm:w-[90rem] w-[45rem] overflow-hidden flex items-center"
        >
            <div className="flex">
                <div className="max-w-[75rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
                    <div className="grid grid-cols-2 md:gap-10 lg:gap-16 items-center">
                        <div className="mb-24 md:mb-0 sm:px-6">
                            <div className="relative">
                                <img className="rounded-xl opacity-95" src={card.imgURL} alt="Description"/>
                                <div className="absolute bottom-0 start-0 -z-[1] translate-y-10 -translate-x-14">
                                    <svg className="max-w-40 h-auto text-slate-400" width="696" height="653" viewBox="0 0 696 653" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="72.5" cy="29.5" r="29.5" fill="currentColor"/>
                                        <circle cx="171.5" cy="29.5" r="29.5" fill="currentColor"/>
                                        <circle cx="270.5" cy="29.5" r="29.5" fill="currentColor"/>
                                        <circle cx="369.5" cy="29.5" r="29.5" fill="currentColor"/>
                                        <circle cx="468.5" cy="29.5" r="29.5" fill="currentColor"/>
                                        <circle cx="567.5" cy="29.5" r="29.5" fill="currentColor"/>
                                        <circle cx="666.5" cy="29.5" r="29.5" fill="currentColor"/>
                                        <circle cx="29.5" cy="128.5" r="29.5" fill="currentColor"/>
                                        <circle cx="128.5" cy="128.5" r="29.5" fill="currentColor"/>
                                        <circle cx="227.5" cy="128.5" r="29.5" fill="currentColor"/>
                                        <circle cx="326.5" cy="128.5" r="29.5" fill="currentColor"/>
                                        <circle cx="425.5" cy="128.5" r="29.5" fill="currentColor"/>
                                        <circle cx="524.5" cy="128.5" r="29.5" fill="currentColor"/>
                                        <circle cx="623.5" cy="128.5" r="29.5" fill="currentColor"/>
                                        <circle cx="72.5" cy="227.5" r="29.5" fill="currentColor"/>
                                        <circle cx="171.5" cy="227.5" r="29.5" fill="currentColor"/>
                                        <circle cx="270.5" cy="227.5" r="29.5" fill="currentColor"/>
                                        <circle cx="369.5" cy="227.5" r="29.5" fill="currentColor"/>
                                        <circle cx="468.5" cy="227.5" r="29.5" fill="currentColor"/>
                                        <circle cx="567.5" cy="227.5" r="29.5" fill="currentColor"/>
                                        <circle cx="666.5" cy="227.5" r="29.5" fill="currentColor"/>
                                        <circle cx="29.5" cy="326.5" r="29.5" fill="currentColor"/>
                                        <circle cx="128.5" cy="326.5" r="29.5" fill="currentColor"/>
                                        <circle cx="227.5" cy="326.5" r="29.5" fill="currentColor"/>
                                        <circle cx="326.5" cy="326.5" r="29.5" fill="currentColor"/>
                                        <circle cx="425.5" cy="326.5" r="29.5" fill="currentColor"/>
                                        <circle cx="524.5" cy="326.5" r="29.5" fill="currentColor"/>
                                        <circle cx="623.5" cy="326.5" r="29.5" fill="currentColor"/>
                                        <circle cx="72.5" cy="425.5" r="29.5" fill="currentColor"/>
                                        <circle cx="171.5" cy="425.5" r="29.5" fill="currentColor"/>
                                        <circle cx="270.5" cy="425.5" r="29.5" fill="currentColor"/>
                                        <circle cx="369.5" cy="425.5" r="29.5" fill="currentColor"/>
                                        <circle cx="468.5" cy="425.5" r="29.5" fill="currentColor"/>
                                        <circle cx="567.5" cy="425.5" r="29.5" fill="currentColor"/>
                                        <circle cx="666.5" cy="425.5" r="29.5" fill="currentColor"/>
                                        <circle cx="29.5" cy="524.5" r="29.5" fill="currentColor"/>
                                        <circle cx="128.5" cy="524.5" r="29.5" fill="currentColor"/>
                                        <circle cx="227.5" cy="524.5" r="29.5" fill="currentColor"/>
                                        <circle cx="326.5" cy="524.5" r="29.5" fill="currentColor"/>
                                        <circle cx="425.5" cy="524.5" r="29.5" fill="currentColor"/>
                                        <circle cx="524.5" cy="524.5" r="29.5" fill="currentColor"/>
                                        <circle cx="623.5" cy="524.5" r="29.5" fill="currentColor"/>
                                        <circle cx="72.5" cy="623.5" r="29.5" fill="currentColor"/>
                                        <circle cx="171.5" cy="623.5" r="29.5" fill="currentColor"/>
                                        <circle cx="270.5" cy="623.5" r="29.5" fill="currentColor"/>
                                        <circle cx="369.5" cy="623.5" r="29.5" fill="currentColor"/>
                                        <circle cx="468.5" cy="623.5" r="29.5" fill="currentColor"/>
                                        <circle cx="567.5" cy="623.5" r="29.5" fill="currentColor"/>
                                        <circle cx="666.5" cy="623.5" r="29.5" fill="currentColor"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div>
                            <blockquote className="relative">
                                <svg className="absolute top-0 start-0 transform -translate-x-8 -translate-y-4 size-24 text-gray-200" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                    <path d="M7.39762 10.3C7.39762 11.0733 7.14888 11.7 6.6514 12.18C6.15392 12.6333 5.52552 12.86 4.76621 12.86C3.84979 12.86 3.09047 12.5533 2.48825 11.94C1.91222 11.3266 1.62421 10.4467 1.62421 9.29999C1.62421 8.07332 1.96459 6.87332 2.64535 5.69999C3.35231 4.49999 4.33418 3.55332 5.59098 2.85999L6.4943 4.25999C5.81354 4.73999 5.26369 5.27332 4.84476 5.85999C4.45201 6.44666 4.19017 7.12666 4.05926 7.89999C4.29491 7.79332 4.56983 7.73999 4.88403 7.73999C5.61716 7.73999 6.21938 7.97999 6.69067 8.45999C7.16197 8.93999 7.39762 9.55333 7.39762 10.3ZM14.6242 10.3C14.6242 11.0733 14.3755 11.7 13.878 12.18C13.3805 12.6333 12.7521 12.86 11.9928 12.86C11.0764 12.86 10.3171 12.5533 9.71484 11.94C9.13881 11.3266 8.85079 10.4467 8.85079 9.29999C8.85079 8.07332 9.19117 6.87332 9.87194 5.69999C10.5789 4.49999 11.5608 3.55332 12.8176 2.85999L13.7209 4.25999C13.0401 4.73999 12.4903 5.27332 12.0713 5.85999C11.6786 6.44666 11.4168 7.12666 11.2858 7.89999C11.5215 7.79332 11.7964 7.73999 12.1106 7.73999C12.8437 7.73999 13.446 7.97999 13.9173 8.45999C14.3886 8.93999 14.6242 9.55333 14.6242 10.3Z" fill="currentColor"/>
                                </svg>
                                <div className="relative z-10">
                                    <p className="text-lg font-semibold text-gray-500 tracking-wide mb-3 ">
                                        {card.title}
                                    </p>
                                    <motion.div
                                        className="text-xl font-medium italic text-orange-500 md:text-2xl md:leading-normal xl:text-3xl xl:leading-normal sm:w-auto w-screen px-4"
                                        variants={{
                                            hidden: { opacity: 0, x: -50 },
                                            visible: { opacity: 1, x: 0 }
                                        }}
                                        initial="hidden"
                                        whileInView="visible"
                                        transition={{duration: 0.6, delay: 0.4}}
                                        viewport={{once: false}}
                                    >
                                        {card.content}
                                    </motion.div>
                                </div>
                                <footer className="mt-6">
                                    <div className="flex items-center">
                                        <div className="ms-4 md:ms-0">
                                            <div className="text-base text-gray-800 ">
                                                <span className="text-gray-600">According to </span>
                                                <span className="italic font-semibold">{card.ref}</span>
                                            </div>
                                        </div>
                                    </div>
                                </footer>
                            </blockquote>
                        </div>
                    </div>
                </div>
                { card.id!==6 ?
                    <motion.div
                        className="text-6xl my-auto ml-24"
                        variants={{
                            hidden: { opacity: 0, x: -50 },
                            visible: { opacity: 1, x: 0 }
                        }}
                        initial="hidden"
                        whileInView="visible"
                        transition={{duration: 0.6, delay: 0.8}}
                        viewport={{once: false}}
                    >
                        <HiArrowRight />
                    </motion.div> :
                    <motion.div
                        className="my-auto text-6xl ml-24"
                        variants={{
                            hidden: { opacity: 0, y: -50 },
                            visible: { opacity: 1, y: 0 }
                        }}
                        initial="hidden"
                        whileInView="visible"
                        transition={{duration: 0.6, delay: 0.8}}
                        viewport={{once: false}}
                    >
                        <BsArrow90DegRight className="rotate-90" />
                    </motion.div> }
            </div>
        </div>
    );
};

const cards = [
    {
        imgURL: "https://static.igem.wiki/teams/5122/homepage/knowledge-1.png",
        title: "Guanine global market",
        content: "With the increasing demands for advanced pharmaceutical and high-quality beauty products, the global guanine market size is expected to reach USD 474.52 million by 2027.",
        ref: "Business Research Insights",
        id: 1,
    },
    {
        imgURL: "https://static.igem.wiki/teams/5122/homepage/knowledge-2.png",
        title: "Synthetic biology in cosmetics",
        content: "The talented synthetic biology is contributing to the cosmetics industry in different manners, including the alteration in desirable properties, environmental impacts and personalized design.",
        ref: "Tomorrow Bio",
        id: 2,
    },
    {
        imgURL: "https://static.igem.wiki/teams/5122/homepage/knowledge-3.png",
        title: "Guanine production in prokaryotes",
        content: "Unprecedented production of extracellular guanine crystals can be observed accumulating for certain species of prokaryotes, which is related to the absence of guanine deaminase.",
        ref: "Pavan, M. E., et al., 2023",
        id: 3,
    },
    {
        imgURL: "https://static.igem.wiki/teams/5122/homepage/knowledge-4.png",
        title: "Enhancing guanine synthesis",
        content: "The presence of GMP synthetase (guaA) and inosine-5′-monophosphate dehydrogenase (guaB) prevents bacteria from guanine auxotrophy.",
        ref: "Kofoed, E. M., et al., 2016",
        id: 4,
    },
    {
        imgURL: "https://static.igem.wiki/teams/5122/homepage/knowledge-5.png",
        title: "Inhibiting guanine degradation",
        content: "Lack of genes encoding guanine deaminase (guaD) and xanthine dehydrogenase (xdh) facilitates the phenotype of guanine crystal accumulation.",
        ref: "Pavan, M. E., et al., 2023",
        id: 5,
    },
    {
        imgURL: "https://static.igem.wiki/teams/5122/homepage/knowledge-6.png",
        title: "Guanine crystal formation",
        content: "The excretion and biomineralization of guanine crystals can be found in multiple species as the result of high-concentration guanine biosynthesis, while the biological controlling mechanism remains unknown.",
        ref: "Hu, H., et al., 2023",
        id: 6,
    }
];

export default function HorizontalScrollKnowledge(){
    return(
        <HorizontalScrollCarousel />
    )
}